import React, { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, Input } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/pro-light-svg-icons';
import {
  setPacientesKeyword,
  loadPacientesWorkspace,
  setFormFilterTiendaState,
} from '../../../../state/actions/creators/pacientes.actioncreator';
import { useBreakpoint } from '../../../../hooks/useBreakpoint';
import { Flex, Box, Text } from '../../../shared/components';
import SelectorTienda from '../../../shared/components/dataEntry/SelectorTienda.dataentry';

export default function FormPatientList({
  pageSize, filterTienda,filterKeyword, onPageChange,
}) {
  const dispatch = useDispatch();

  const { loadingTiendas } = useSelector(state => state.pacientesWorkspace);
  const permisos = useSelector(state => state.auth.permisos.permiso);
  const keywordState = useSelector(state => state.pacientesWorkspace.keyword);
  const tiendaId = useSelector(state => state.auth.user.user_info.tienda_id);
  const actualPage = useSelector(state => state.pacientesWorkspace.page);
  const actualSorter = useSelector(state => state.pacientesWorkspace.sorter);

  const { isDesktop } = useBreakpoint();

  const [formFilterTienda, setFormFilterTienda] = useState(filterTienda);
  const [keyword, setKeyword] = useState(filterKeyword);
  const [keywordPrev, setKeywordPrev] = useState(filterKeyword);
  const [filterSorter] = useState(null);

  const searchKeyword = () => {
    sessionStorage.removeItem('payloadGetPacientes');
    setKeyword(keywordPrev);
    dispatch(setPacientesKeyword(keywordPrev));
  };

  const searchInputRef = useRef();
  const searchInput = (
    <Input
      ref={searchInputRef}
      placeholder="Búsqueda"
      defaultValue={filterKeyword}
      onPressEnter={(event) => {
        sessionStorage.removeItem('payloadGetPacientes');
        setKeyword(event.target.value);
        dispatch(setPacientesKeyword(event.target.value));
      }}
      onChange={(event) => {
        setKeywordPrev(event.target.value);
      }}
      suffix={<FontAwesomeIcon className="pointer" icon={faSearch} onClick={searchKeyword} />}
    />
  );
  const setFormFilterTiendaFunc = (value) => {
    dispatch(setFormFilterTiendaState(value))
    setFormFilterTienda(value);
  } 
  useEffect(() => {
    if (searchInputRef && searchInputRef.current != undefined) {
      searchInputRef.current.state.value = keywordState;
    }
    setKeyword(keywordState);
  }, [keywordState]);

  useEffect(() => {
    const tiendaAll = -1;
    if (formFilterTienda === '') {
      setFormFilterTienda(permisos.acceso_paciente_otra_tienda === 'T' ? tiendaAll : tiendaId);
    }
    // TODO: Review to include keywords and filterCity
    if (formFilterTienda != 'All') {
      dispatch(loadPacientesWorkspace({
        tiendaId: formFilterTienda, keyword, page: actualPage, pageSize, sorter: actualSorter
      }));
    } else {
      dispatch(loadPacientesWorkspace({
        tiendaId: tiendaAll, keyword, page: actualPage, pageSize, sorter: actualSorter
      }));
    }
    //onPageChange(1);
  }, [keyword, formFilterTienda]);

  return (
    <Flex
      alignItems="flex-end"
      width={isDesktop ? '60%' : '100%'}
      mx="auto"
    >
      <Flex
        mx="8px"
        flexDirection="column"
        width="30%"
      >
        <Text
          translationId="generico.tienda"
          fontSize="16px"
          mb={4}
        />
        <SelectorTienda
          permisoOtrasTiendas={permisos.acceso_paciente_otra_tienda === 'T'}
          loading={loadingTiendas}
          onChange={value => setFormFilterTiendaFunc(value)}
          style={{
            width: '100%',
          }}
        />
      </Flex>
      <Flex
        mx="8px"
        flexDirection="column"
        width="50%"
      >
        <Text
          translationId="pacientes.cliente"
          fontSize="16px"
          mb={4}
        />
        {searchInput}
      </Flex>
      <Box
        mx="8px"
        flexDirection="column"
        width="100px"
      >
        <Button
          type="primary"
          style={{
            width: '100px',
          }}
          onClick={searchKeyword}
        >
          <Text
            translationId="pacientes.consultar"
          />
        </Button>
      </Box>
    </Flex>
  );
}

FormPatientList.propTypes = {
  pageSize: PropTypes.number,
  filterTienda: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  onPageChange: PropTypes.func,
};

FormPatientList.defaultProps = {
  pageSize: 20,
  filterTienda: 'All',
  onPageChange: () => {},
};
